// Bridges the OIDC auth state (managed by react-oidc-context inside React) to the
// axios layer (created outside React). AuthBridge pushes the current access token
// here; api-utils reads it per request. The selected instance is the user's chosen
// tenant, sent as the X-Instance-Id header and validated server-side.

let accessToken: string | null = null;

export const setAccessToken = (token: string | null) => {
    accessToken = token;
};

export const getAccessToken = (): string | null => accessToken;

const INSTANCE_KEY = "selectedInstanceId";

export const setSelectedInstanceId = (id: number | null) => {
    if (id == null) {
        localStorage.removeItem(INSTANCE_KEY);
    } else {
        localStorage.setItem(INSTANCE_KEY, String(id));
    }
};

export const getSelectedInstanceId = (): number | null => {
    const value = localStorage.getItem(INSTANCE_KEY);
    return value ? Number(value) : null;
};
